/* tslint:disable */

/**
 */
export class SavePackingLayer_packingLayers {
    ID_PACKING_ELMT?: number;
    PACKING_SIDE_NUMBER?: number;
    PACKING_LAYER_ORDER?: number;
    THICKNESS?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/save-packing-layer-_packing-layers.ts